import React, { useEffect, useMemo } from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { Icon } from "components/common";
import { Button } from "components/bootstrap";
import { useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
import { Row } from "security-app/components/common/FormBaseStyles";
import { WindowHeader, WindowBody, IconButton } from "./styledComponents";
import RuleInfoTooltip from "./RuleTooltip";
const RemoveButton = styled(IconButton)`
  opacity: 0.3;

  &:hover {
    opacity: 0.9;
  }
`;
const InvalidIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  color: ${({ theme }) => theme.colors.variant.danger};
  font-weight: bold;
`;
const RuleTitleButton = styled(Button)`
  padding: 0;
  color: ${({ $isInvalid, theme }) => $isInvalid ? theme.colors.variant.danger : theme.colors.text.primary};
`;
const RuleTitle = ({ rule, onTitleClick }) => {
  const { t } = useTranslation("enterprise_security_sigma");
  const selectedRulesDispatch = useSelectedRowsDispatch();
  const { errors } = useFormikContext();
  const isInvalid = useMemo(() => {
    var _a;
    return !!((_a = errors.rule_overrides) == null ? void 0 : _a[rule.id]);
  }, [errors, rule.id]);
  const onRuleRemove = (e) => {
    e.stopPropagation();
    selectedRulesDispatch({ type: "remove", payload: [rule] });
  };
  return /* @__PURE__ */ React.createElement(Row, { $gap: "0.4rem", $align: "center", style: { padding: "8px 0" } }, /* @__PURE__ */ React.createElement(RemoveButton, { $delete: true, "data-testid": "unselect-rule", onClick: onRuleRemove }, /* @__PURE__ */ React.createElement(Icon, { type: "solid", style: { cursor: "pointer" }, name: "close", title: t("right_panel.remove_rule") })), /* @__PURE__ */ React.createElement(RuleInfoTooltip, { rule }), /* @__PURE__ */ React.createElement(RuleTitleButton, { onClick: () => onTitleClick(rule), $isInvalid: isInvalid, bsStyle: "link" }, rule.title), isInvalid && /* @__PURE__ */ React.createElement(InvalidIndicator, { "data-testid": `invalid-indicator-${rule.id}` }, /* @__PURE__ */ React.createElement(Icon, { name: "warning" }), " ", t("right_panel.invalid_options")));
};
function RightPanel({ onSelectionChange, setSelectedRule }) {
  const { t } = useTranslation("enterprise_security_sigma");
  const selectedRules = useSelectedRows();
  const selectedRulesDispatch = useSelectedRowsDispatch();
  useEffect(() => {
    setSelectedRule(selectedRules[0]);
    onSelectionChange(selectedRules.map((rule) => rule.id));
  }, [selectedRules, onSelectionChange, setSelectedRule]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(WindowHeader, { style: { justifyContent: "space-between" } }, t("right_panel.selected_rules", { count: selectedRules.length }), selectedRules.length > 0 && /* @__PURE__ */ React.createElement(IconButton, { "data-testid": "clear-selection", onClick: () => selectedRulesDispatch({ type: "clear" }) }, /* @__PURE__ */ React.createElement(Icon, { style: { cursor: "pointer" }, size: "xs", name: "close", title: t("right_panel.clear_selection") }))), /* @__PURE__ */ React.createElement(WindowBody, null, selectedRules.map((rule) => /* @__PURE__ */ React.createElement(RuleTitle, { key: rule.id, rule, onTitleClick: setSelectedRule }))));
}
export default RightPanel;
